module.exports = __webpack_public_path__ + "static/hero-8ff0ab1f8894fdbc3713d30e815e3e25.jpg";